import React from 'react'
import PropTypes from 'prop-types'
import { Select } from 'antd'

UserFilters.propTypes = {
    userName: PropTypes.string,
    onChangeUserName: PropTypes.func.isRequired,
    isActive: PropTypes.bool,
    handleChageStatus: PropTypes.func.isRequired,
}

function UserFilters(props) {
    const { userName, onChangeUserName, handleChageStatus, isActive } = props

    const _handleChangeInput = (e) => {
        const { value } = e.target

        if (typeof onChangeUserName === 'function') {
            onChangeUserName(value.trim())
        }
    }

    const _handleChangeStatus = (value) => {
        if (typeof handleChageStatus === 'function') {
            handleChageStatus(value)
        }
    }

    return (
        <div className='UserFilters d-flex'>
            <div className="SearchUserName">
                <textarea placeholder="Search username" value={userName} onChange={_handleChangeInput} />
                <i className="fa fa-search" />
            </div>
            <div className="StatusUserName">
                <Select
                    value={isActive || []}
                    placeholder="Select status"
                    className='StatusUserName'
                    onChange={_handleChangeStatus}
                    style={{ width: 345 }}
                >
                    <Select.Option value={'active'}>Active</Select.Option>
                    <Select.Option value={'inactive'}>Inactive</Select.Option>
                </Select>
            </div>
        </div>
    )
}

export default UserFilters
